export default {
  support: {
    doc: 'Help Documentation',
    manual: 'User Manual',
    client: 'AI Client',
    error: 'Common Errors',
    popupError: 'Popup Errors',
    win7Error: 'Win7 Client Error After Installation',
  },
}
